const PENDING_KEY = 'gtm_pending_events';
const SENT_KEY = 'gtm_sent_event_ids';
const TTL_MS = 10 * 60 * 1000;
const SENT_LIMIT = 500;

function safeRead(key, fallback) {
  try {
    return JSON.parse(sessionStorage.getItem(key) || JSON.stringify(fallback));
  } catch (_error) {
    return fallback;
  }
}

function safeWrite(key, value) {
  try {
    sessionStorage.setItem(key, JSON.stringify(value));
  } catch (_error) {
    // ignore storage write errors (quota/private mode)
  }
}

export function enqueueEvent(payload) {
  const current = safeRead(PENDING_KEY, []);
  current.push(payload);
  safeWrite(PENDING_KEY, current);
}

export function flushPending(pushFn) {
  const pending = safeRead(PENDING_KEY, []);
  if (!pending.length) return;

  const now = Date.now();
  const validEvents = pending.filter((event) => now - (event.ts || now) < TTL_MS);
  validEvents.forEach((event) => pushFn(event));
  safeWrite(PENDING_KEY, []);
}

export function wasSent(eventId) {
  if (!eventId) return false;
  const sentIds = safeRead(SENT_KEY, []);
  return sentIds.includes(eventId);
}

export function markSent(eventId) {
  if (!eventId) return;

  const sentIds = safeRead(SENT_KEY, []);
  if (!sentIds.includes(eventId)) sentIds.push(eventId);
  safeWrite(SENT_KEY, sentIds.slice(-SENT_LIMIT));
}
